module.exports = __webpack_public_path__ + "static/img/profile.dad52f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile.jpg
// module id = F8+k
// module chunks = 1